import {
  EMPTY_ADDRESS,
  EMPTY_ADDRESS_ERRORS,
  Address,
  AddressErrors,
  TrackedRecord,
  TenantRecord,
} from "./commons";

export const AGENT_TITLES: Record<string, string> = {
  Mr: "Mr",
  Mrs: "Mrs",
  Miss: "Miss",
  Ms: "Ms",
  Dr: "Doctor",
  Rev: "Revernend",
};

export interface AgentContact {
  title?: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  address: Address;
  type: "primary" | "visa" | "none";
}

export interface AgentContactError {
  title: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  address: AddressErrors;
  type: string;
}

export interface AgentUkviSettings {
  enabled: boolean;
  agentEmail: string;
  agentPhone: string;
  useDedicatedWorkerPhone: boolean;
  workerPhone: string;
}

export interface AgentUkviSettingsErrors {
  agentEmail: string;
  agentPhone: string;
  workerPhone: string;
}

export interface Agent extends TrackedRecord, TenantRecord {
  title?: string;
  name: string;
  surname: string;
  company: string;
  email: string;
  phone?: string;
  address: Address;
  hideForCos?: boolean;
  contacts: AgentContact[];
  ukviSettings?: AgentUkviSettings;
}

export interface AgentErrors {
  title: string;
  name: string;
  surname: string;
  company: string;
  email: string;
  phone: string;
  address: AddressErrors;
  sponsorId: string;
  contacts: AgentContactError[];
  ukviSettings: AgentUkviSettingsErrors;
}

export type AgentsDict = Record<string, Agent>;
export type AgentDoc = { id: string; agent: Agent };

export const EMPTY_AGENT: Agent = {
  name: "",
  surname: "",
  company: "New Agent",
  email: "",
  address: { ...EMPTY_ADDRESS },
  sponsorId: "",
  contacts: [],
};

export const EMPTY_AGENT_CONTACT: AgentContact = {
  name: "",
  surname: "",
  email: "",
  phone: "",
  address: { ...EMPTY_ADDRESS },
  type: "none",
};

export const EMPTY_AGENT_UKVI_SETTINGS: AgentUkviSettings = {
  enabled: false,
  agentEmail: "",
  agentPhone: "",
  useDedicatedWorkerPhone: false,
  workerPhone: "",
};

export const EMPTY_AGENT_CONTACT_ERROR: AgentContactError = {
  title: "",
  name: "",
  surname: "",
  email: "",
  phone: "",
  address: { ...EMPTY_ADDRESS_ERRORS },
  type: "",
};

export const EMPTY_AGENT_UKVI_SETTINGS_ERRORS: AgentUkviSettingsErrors = {
  agentEmail: "",
  agentPhone: "",
  workerPhone: "",
};

export const EMPTY_AGENT_ERRORS: AgentErrors = {
  title: "",
  name: "",
  surname: "",
  company: "",
  email: "",
  phone: "",
  address: { ...EMPTY_ADDRESS_ERRORS },
  sponsorId: "",
  contacts: Array(1).fill({ ...EMPTY_AGENT_CONTACT_ERROR }),
  ukviSettings: { ...EMPTY_AGENT_UKVI_SETTINGS_ERRORS },
};
